/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AiProcessRequest } from '../model/models';
import { InlineObject1 } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface AIServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Process text with AI API
     * 
     * @param aiProcessRequest 
     */
    aiProcess(aiProcessRequest: AiProcessRequest, extraHttpRequestParams?: any): Observable<object>;

}
